// extracted by mini-css-extract-plugin
module.exports = {"SectionPodcast":"SectionPodcast_SectionPodcast__XBIUe"};